import React from 'react';
import './style.scss'
import Modal from "../modal";
import {useSystem} from "../../../hooks/use-system";
import {useEthers} from "@usedapp/core";


function NoProvider({...props}) {

    const system = useSystem();
    const {account} = useEthers();

    if (account) {
        system.showModal('');
    }

    return (
        <Modal {...props} title="Connecting To...">
            <div className={'text-center connectingWalletLabel'}>
               No Ethereum provider detected!
            </div>
        </Modal>
    );
}

export default NoProvider;
